// Libraries
import React from 'react'
import Flatpickr from 'react-flatpickr'
import PropTypes from 'prop-types'
import { date } from 'helpers/format'

// Icons
import IconCalendar from 'ui/Icons/IconCalendar'

// Styles
import './DateRange.scss'

function DateRange({ value, placeholder, format, onChange, ...props }) {
  const close = (newValue) => {
    const formatted = newValue.map((x) => {
      return date(x, 'MM/dd/yyyy')
    })

    if (value && value.length === formatted.length) {
      if (value[0] === formatted[0] && value[1] === formatted[1]) {
        return
      }
    }

    if (formatted.length === 2) {
      if (formatted[0] !== formatted[1]) {
        onChange(formatted)
        return
      }
    }

    onChange([])
  }

  return (
    <div className="flatpickr date-range-wrapper">
      <Flatpickr
        className="date-picker"
        value={value}
        options={{ mode: 'range', dateFormat: format }}
        placeholder={placeholder}
        onClose={close}
        {...props}
      />
      <div className="--icon-date">
        <IconCalendar width={'20px'} />
      </div>
    </div>
  )
}

DateRange.propTypes = {
  value: PropTypes.array,
  format: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
}

DateRange.defaultProps = {
  value: [],
  format: 'm/d/Y',
  placeholder: 'Date range',
  onChange: () => {},
}

export default DateRange
